export { default as CompanyOperationsCompactTable } from './CompanyOperationsCompactTable';
